import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { RoleListResponse, RoleDetail } from '@/types/settings';

export function useRoles() {
  return useApiQuery<RoleListResponse>({
    queryKey: settingsKeys.roles(),
    queryFn: () => apiGet<RoleListResponse>(operationsClient, settingsEndpoints.roles()),
    showErrorToast: false,
  });
}

export function useRoleDetail(roleId: string | undefined) {
  return useApiQuery<RoleDetail>({
    queryKey: settingsKeys.roleDetail(roleId ?? ''),
    queryFn: () => apiGet<RoleDetail>(operationsClient, settingsEndpoints.roleDetail(roleId!)),
    enabled: !!roleId,
    showErrorToast: false,
  });
}
